import {
    getExpensesByLevels,
    getExpensesCharts,
    getExpensesComparison,
} from "@/api/financialReport";
import { createReportModule } from "./utils/createReportModule";

// Cuentas level_2 cuya suma forma el numerador del ratio "% Gastos / Ventas".
// Coincide con el cálculo de `gastos/ventas_%` en ResultadosTab (ver
// reportStructure.js: keysSum = ['gastos_administracion', 'gastos_comerciales',
// 'gastos_i+d']), excluyendo `gastos_no_operacional` a propósito.
const EFFICIENCY_L2_ACCOUNTS = [
    "Gastos De Administración",
    "Gastos Comerciales",
    "Gastos I+D",
];

// Reporte de Gastos (tabla de evolución + gráficos + comparación + summary).
// Espejo de costsReport; toda la mecánica vive en createReportModule.
export default createReportModule({
    apiFns: {
        byLevels: getExpensesByLevels,
        charts: getExpensesCharts,
        comparison: getExpensesComparison,
    },
    ratioL2Accounts: EFFICIENCY_L2_ACCOUNTS,
    ratioLabel: "% Gastos / Ventas",
    totalLabel: "Total Gastos",
    fetchActionNames: {
        data: "fetchExpensesData",
        charts: "fetchExpensesCharts",
        comparison: "fetchExpensesComparison",
    },
    logPrefix: "[expensesReport]",
    errorMessages: {
        data: "Error al cargar gastos.",
        charts: "Error al cargar gráficos de gastos.",
    },
});
